module.exports = __webpack_public_path__ + "img/14.ad1e3978.png";